export default {
	section_banner: {
		title: {
			one: 'Use Of',
		},
		main_title: {
			one: 'International',
		},
		sub_title: {
			one: 'Standard Wallets',
		},
		paragraph: {
			one: 'Secured by security, our own wallet We use a wallet developed with our own technology, not an external wallet company.',
		},
		cta_buttons: {
			one: 'Send Asset',
			two: 'Download App',
		},
	},

	wallet_sec_rt: {
		label: 'Security Level 2',
		title: {
			one: 'Higher Compliance',
			two: 'With',
			three: 'International',
			four: 'Standards',
		},
		paragraph:
			'We take extra care when it comes to security, ensuring that every layer of our system is protected against threats. To completely block hacking, JPWorldPay uses advanced encryption, decentralized storage, and continuous monitoring.',
		cta_buttons: {
			one: 'Get Started',
		},
	},

	wallet_sec_lt: {
		label: 'Fastest Payment System',
		title: {
			one: 'Hacking',
			two: 'Remains Extremely',
			three: 'Difficult',
		},
		paragraph:
			'Additionally, JPWorldPay employs decentralized storage principles to minimize central points of failure. Our encryption protocols safeguard every transaction with industry-leading standards. With proactive security strategies in place, your digital assets are always defended against emerging threats. We also partner with cybersecurity experts to conduct regular audits and strengthen our infrastructure.',
		cta_buttons: {
			one: 'Get Started',
		},
	},

	received_request_sec: {
		label: '3 Steps Payment',
		title: {
			one: 'A',
			two: 'Wallet',
			three: 'Is Like Your',
			four: 'Safe',
		},
		paragraph: {
			one: 'We at JPWorldPay have created our own wallet and have put security measures in place to ensure it is optimized against hacking. We are confident in its security. Our system undergoes regular testing to identify and fix potential vulnerabilities. Your assets are protected with advanced encryption and	multi-layered defenses.',
			two: 'In addition, we continuously monitor for suspicious activity and implement real-time alerts to detect and prevent threats before they can impact your account. With JPWorldPay, you can manage your digital assets with confidence, knowing your security is always our top priority. We also ensure that all data is stored in secure, access-controlled environments. Our development team follows best practices for cybersecurity and compliance. With every transaction, your privacy and protection remain at the core of our platform.',
		},

		cta_buttons: {
			one: 'Receive Now',
		},
	},

	section_newsletter: {
		label: 'SUBSCRIBE NEWSLETTER',
		title: {
			one: 'Subscribe',
			two: '& Get A Latest Update',
		},
		description: {
			one: 'Subscribe us & recieve our offers and updates in your inbox directly.',
			two: 'Get in touch to learn how our JPWorldPay solution can increase your business.',
		},
		form: {
			placeholder: 'Email ID',
			button: 'SUBSCRIBE NOW',
		},
	},
};
